module.exports = __webpack_public_path__ + "71688c7e283d6dbc27f99e5405bd5512.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-30.png
// module id = 119
// module chunks = 0